import React from 'react';
import PropTypes from 'prop-types';

import { PieChart, Pie, Cell, Sector } from 'recharts';
import { Icon } from '../Elements';

import classes from './DiagramChart.module.scss';

const COLORS = [
  '#00CC87',
  '#9A61D2',
  '#FFD6D7',
  '#FA248C',
  '#4D4476',
  '#E0E0F3',
  '#C9FCD7'
];

const renderActiveShape = props => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    percent,
    value
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 0) * cos;
  const sy = cy + (outerRadius + 0) * sin;
  const mx = cx + (outerRadius + 10) * cos;
  const my = cy + (outerRadius + 10) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 10;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />

      <text
        x={ex + (cos >= 0 ? 1 : -1) * 2}
        y={ey}
        dy={5}
        textAnchor={textAnchor}
        fill={fill}
      >
        {`${value}(${(percent * 100).toFixed(1)}%)`}
      </text>
    </g>
  );
};

const DiagramChart = ({
  onDownload,
  data,
  nameChart,
  idBtnDownload,
  isAnimation = true
}) => {
  return (
    <div className={classes.diagramChart}>
      <h2 className={classes.title}>{nameChart}</h2>
      <div className={classes.diagramChartArea}>
        {/* eslint-disable-next-line */}
        <a id={idBtnDownload} download="chart.png" />
        <button
          type="button"
          className={classes.downloadButton}
          onClick={() => onDownload(data, nameChart)}
        >
          <Icon icon={'Icn_Download-1'} className={classes.iconDownload} />
        </button>
        <PieChart width={356 - 32} height={220}>
          <Pie
            activeIndex={data.map((v, index) => index)}
            activeShape={renderActiveShape}
            data={data}
            dataKey="value"
            cx={'50%'}
            cy={'50%'}
            innerRadius={58 - 10}
            outerRadius={75 - 10}
            blendStroke
            legendType={'rect'}
            isAnimationActive={isAnimation}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
        </PieChart>
        <div className={classes.legend}>
          {data.map((entry, index) => (
            <div key={`legend-${index}`} className={classes.legendItem}>
              <div
                className={classes.legendIcon}
                style={{ backgroundColor: `${COLORS[index % COLORS.length]}` }}
              ></div>
              {entry.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

DiagramChart.propTypes = {
  onDownload: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  nameChart: PropTypes.string.isRequired,
  idBtnDownload: PropTypes.string,
  isAnimation: PropTypes.bool
};

export default DiagramChart;
